class Queue {

  _isRunning = true

  constructor() {
    this.items = [];
  }

  isRunning() {
    return this._isRunning
  }

  stop() {
    this._isRunning = false
  }

  start() {
    this._isRunning = true
  }

  enqueue(item) {
    this.items.push(item);
  }

  isEmpty() {
    return this.items.length === 0;
  }

  dequeue() {
    if (this.isEmpty()) {
      return "Queue is empty";
    }
    return this.items.shift();
  }

  next() {
    if (this.isEmpty()) {
      return "Queue is empty";
    }
    return this.items[0];
  }

  size() {
    return this.items.length;
  }
}

export default Queue